import request from '../utils/request'

export function surveyAppListPageApi (params) {
  return request({
    url: '/api/survey/appListPage',
    method: 'get',
    params
  })
}

export function surveyInputInfoApi (surveyId) {
  return request({
    url: `api/survey/inputInfo/${surveyId}`,
    method: 'get'
  })
}

export function supportRivalListApi (params) {
  return request({
    url: 'api/support/rivalList',
    method: 'get',
    params
  })
}

export function surveyFormInputApi (data) {
  return request({
    url: 'api/survey/formInput',
    method: 'post',
    data
  })
}
